import { createSlice } from '@reduxjs/toolkit';

export const WorkshopTimeSlice = createSlice({
  name: 'workshopTime',
  initialState: {
    tickets: [],
    rowsFilters: [],
    sortConfig: [],
  },
  reducers: {
    setTickets: (state, action) => {
      state.tickets = action.payload;
    },
    setRowsFiltersForWorkshopTime: (state, action) => {
      const list = state.rowsFilters.filter(
        (item) => item.cell === action.payload.cell,
      );
      if (list.length > 0) {
        state.rowsFilters = state.rowsFilters.filter(
          (item) => item !== list[0],
        );
      }
      state.rowsFilters.push(action.payload);
    },
    initializeRowsFiltersForWorkshopTime: (state) => {
      state.rowsFilters = [];
    },
    setSortConfigForWorkshopTime: (state, action) => {
      state.sortConfig = action.payload;
    },
  },
});
export const {
  setTickets,
  setRowsFiltersForWorkshopTime,
  setSortConfigForWorkshopTime,
  initializeRowsFiltersForWorkshopTime,
} = WorkshopTimeSlice.actions;

export const ticketsForWorkshopTimeState = (state) =>
  state.workshopTime.tickets;
export const rowsFiltersForWorkshopTimeState = (state) =>
  state.workshopTime.rowsFilters;
export const sortConfigForWorkshopTimeState = (state) =>
  state.workshopTime.sortConfig;

export default WorkshopTimeSlice.reducer;
